import { render, staticRenderFns } from "./PlateTextItem.vue?vue&type=template&id=4f6c57f4"
import script from "./PlateTextItem.vue?vue&type=script&lang=js"
export * from "./PlateTextItem.vue?vue&type=script&lang=js"
import style0 from "./PlateTextItem.vue?vue&type=style&index=0&id=4f6c57f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports